import { CronosProjectsPage } from "./../cronos-projects/cronos-projects";
import { SurveyPage } from "./../survey/survey";
import { TrainingPage } from "./../training/training";
import { Subscription } from "rxjs";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  Loading,
  LoadingController,
  ToastController,
} from "ionic-angular";
import { IntermarketingDetailsPage } from "../intermarketing-details/intermarketing-details";
import { NotificationModel } from "../../model/NotificationModel";
import { Store } from "../../../node_modules/@ngrx/store";
import { AppStore } from "../../store/AppStore";
import {
  ListNotificationsAction,
  ClearNotificationsAction,
} from "../../store/action/NotificationActions";
import { SurveyClearErrorsAction } from "../../store/action/SurveyActions";
import { TrainingClearErrorsAction } from "../../store/action/TrainingActions";
import { BrainstormClearErrorsAction } from "../../store/action/BrainstormActions";
import { LogoutAction } from "../../store/action/UserActions";
import { LoginPage } from "../login/login";
import { NotificationService } from "../../services/NotificationService";
import { DatePipe } from "@angular/common";
import { environment } from "../../environments/environment";
import { CronosClearErrorsAction } from "../../store/action/CronosActions";

declare var swRegistration: any;
@IonicPage()
@Component({
  selector: "page-intermarketing",
  templateUrl: "intermarketing.html",
  providers: [DatePipe],
})
export class IntermarketingPage {
  public clientId: number = null;
  public userId: number = null;

  public notificationItems: Array<NotificationModel> = [];
  public filteredItems: Array<NotificationModel> = [];
  public monthList: Array<{
    year: number;
    month: number;
    description: string;
    items: Array<NotificationModel>;
  }> = new Array<{
    year: number;
    month: number;
    description: string;
    items: Array<NotificationModel>;
  }>();
  public searchInput: string = null;
  public shouldShowCancelSearch: boolean = false;
  public selectedType: string = "1";
  public isLoading: boolean;
  public loader: Loading;
  public type: number = 1;

  private loggingOff: boolean;
  private refresher: any = null;
  private clickedItem: NotificationModel;

  private userStateSubscription: Subscription;
  private notificationStateSubscription: Subscription;

  private id: number;
  private messageId: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public notificationService: NotificationService,
    private store: Store<AppStore>,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private datePipe: DatePipe
  ) {
    this.clickedItem = null;
    if (this.navParams.get("id")) {
      this.id = this.navParams.get("id");
    }
    if (this.navParams.get("messageId")) {
      this.messageId = this.navParams.get("messageId");
    }
  }

  ionViewDidLoad() {
    this.loggingOff = false;
    if (this.navParams.get("type")) {
      this.type = this.navParams.get("type");
    }
    if (this.navParams.get("clickedItem")) {
      this.clickedItem = this.navParams.get("clickedItem");
    }
  }

  ionViewDidEnter() {
    this.userStateSubscription = this.store
      .select("userState")
      .subscribe((userState) => {
        if (userState.expired == true && !this.loggingOff) {
          this.loggingOff = true;
          this.logoff();
        }
        if (userState.user != null) {
          this.clientId = userState.user.clienteId;
          this.userId = userState.user.id;
          this.store.dispatch(
            new ListNotificationsAction({
              clientId: this.clientId,
              userId: this.userId,
            })
          );
        }
      });
    this.notificationStateSubscription = this.store
      .select("notificationState")
      .subscribe((notificationState) => {
        if (notificationState.loading && !this.isLoading) {
          if (this.loader == null) {
            this.loader = this.loadingCtrl.create({
              content: "Aguarde...",
            });
            this.loader.present();
          }
          this.isLoading = true;
        }
        if (!notificationState.loading && this.isLoading) {
          this.loader.dismiss();
          this.loader = null;
          this.isLoading = false;
        }
        if (notificationState.error) {
          setTimeout(() => {
            if (!this.loggingOff) {
              this.presentToast("Erro ao trazer as notificações");
              if (this.refresher != null) {
                this.refresher.complete();
                this.refresher = null;
              }
            }
          }, 200);
        }
        if (notificationState.data != null) {
          if (this.type == 1) {
            this.notificationItems = notificationState.data
              .filter((x) => x.servicoNotificacao == 3)
              .sort((a, b) => {
                return b.dataInicial > a.dataInicial ? 1 : -1;
              });
          } else {
            this.notificationItems = notificationState.data.sort((a, b) => {
              return b.dataInicial > a.dataInicial ? 1 : -1;
            });
          }
          if (this.refresher != null) {
            this.refresher.complete();
            this.refresher = null;
          }
          this.changeList(null);
          if (this.id != null && this.messageId != null && !this.isLoading) {
            this.navCtrl.push(IntermarketingDetailsPage, {
              id: this.id,
              messageId: this.messageId,
            });
            this.id = null;
            this.messageId = null;
          } else if (this.clickedItem != null) {
            this.details(this.clickedItem);
            this.clickedItem = null;
          }
        }
      });
  }

  ionViewWillLeave() {
    if (this.userStateSubscription != null)
      this.userStateSubscription.unsubscribe();
    if (this.notificationStateSubscription != null)
      this.notificationStateSubscription.unsubscribe();
  }

  logoff() {
    this.presentToast("Acesso expirado. Efetue login novamente. (7)");
    localStorage.removeItem("expirationDate");
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  refreshData(ref) {
    this.refresher = ref;
    this.store.dispatch(
      new ListNotificationsAction({
        clientId: this.clientId,
        userId: this.userId,
      })
    );
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "top",
    });
    toast.present();
  }

  changeList(e) {
    if (this.selectedType == "1") {
      this.filteredItems = this.notificationItems.filter(
        (x) => x.status == 0 || x.status == 1
      );
    } else {
      this.filteredItems = this.notificationItems.filter(
        (x) => x.status == 2 || x.status == 3
      );
    }
    this.changeMonthList();
  }

  changeMonthList() {
    if (this.type == 1) {
      this.monthList = new Array<{
        year: number;
        month: number;
        description: string;
        items: Array<NotificationModel>;
      }>();
      this.filteredItems.forEach((item) => {
        if (item.dataInicial != null) {
          const startDate = new Date(item.dataInicial);
          if (
            !this.monthList.find(
              (x) =>
                x.year == startDate.getFullYear() &&
                x.month == startDate.getMonth()
            )
          ) {
            this.monthList.push({
              year: startDate.getFullYear(),
              month: startDate.getMonth(),
              description: this.getMonthsDescription(startDate),
              items: null,
            });
          }
        }
        if (item.midiaId != null && item.midiaData == null) {
          this.notificationService
            .getMedia(this.clientId, item.midiaId)
            .subscribe(
              (resp) => {
                item.midiaData = resp;
              },
              (err) => {
                this.presentToast("Erro ao carregar a mídia da mensagem");
              }
            );
        } else if (
          item.midiaSRC != null &&
          item.midiaSRC.indexOf(environment.apiURL) < 0
        ) {
          item.midiaSRC = environment.apiURL + item.midiaSRC;
        }
      });
      this.monthList = this.monthList.sort((a, b) => {
        if (a.year == b.year) {
          return b.month > a.month ? 1 : -1;
        } else {
          return b.year > a.year ? 1 : -1;
        }
      });
      this.monthList.forEach((month) => {
        month.items = this.filteredItems.filter(
          (x) =>
            x.dataInicial == null ||
            (new Date(x.dataInicial).getFullYear() == month.year &&
              new Date(x.dataInicial).getMonth() == month.month)
        );
      });
    }
  }

  getMonthsDescription(date: Date) {
    switch (date.getMonth()) {
      case 0:
        return "Janeiro";
      case 1:
        return "Fevereiro";
      case 2:
        return "Março";
      case 3:
        return "Abril";
      case 4:
        return "Maio";
      case 5:
        return "Junho";
      case 6:
        return "Julho";
      case 7:
        return "Agosto";
      case 8:
        return "Setembro";
      case 9:
        return "Outubro";
      case 10:
        return "Novembro";
      case 11:
        return "Dezembro";
    }
  }

  search(e) {
    this.shouldShowCancelSearch = true;
    if (this.selectedType == "1") {
      this.filteredItems = this.notificationItems.filter(
        (x) =>
          (x.status == 0 || x.status == 1) &&
          (x.tituloNotificacao.indexOf(this.searchInput) >= 0 ||
            x.textoNotificacao.indexOf(this.searchInput) >= 0 ||
            this.datePipe
              .transform(new Date(x.dataInicial), "dd/MM/yyyy")
              .indexOf(this.searchInput) >= 0 ||
            this.getMonthsDescription(new Date(x.dataInicial)).indexOf(
              this.searchInput
            ) >= 0)
      );
    } else {
      this.filteredItems = this.notificationItems.filter(
        (x) =>
          (x.status == 2 || x.status == 3) &&
          (x.tituloNotificacao.indexOf(this.searchInput) >= 0 ||
            x.textoNotificacao.indexOf(this.searchInput) >= 0 ||
            this.datePipe
              .transform(new Date(x.dataInicial), "dd/MM/yyyy")
              .indexOf(this.searchInput) >= 0 ||
            this.getMonthsDescription(new Date(x.dataInicial)).indexOf(
              this.searchInput
            ) >= 0)
      );
    }
    this.changeMonthList();
  }

  cancelSearch(e) {
    this.searchInput = "";
    this.shouldShowCancelSearch = false;
    this.changeList(null);
  }

  details(item: NotificationModel) {
    if (item.status == 1) {
      let itemCopy: NotificationModel = item;
      itemCopy.status = 2;
      this.notificationService.updateNotification(itemCopy).subscribe(
        (resp) => {
          if (swRegistration) {
            swRegistration.getNotifications().then(function (notifications) {
              notifications.forEach((notificationObject) => {
                if (notificationObject.data == item.id.toString()) {
                  notificationObject.close();
                }
              });
            });
          }
          this.navigateNotification(item);
        },
        (err) => {
          this.presentToast("Erro ao atualizar status da notificação");
        }
      );
    } else {
      this.navigateNotification(item);
    }
  }

  navigateNotification(item: NotificationModel) {
    if (item.servicoNotificacao == 1) {
      const linkArraySurvey: Array<string> = item.linkNotificacao.split("?");
      const linkDataSurvey: Array<string> =
        linkArraySurvey[linkArraySurvey.length - 1].split("-");
      this.navCtrl.setRoot(SurveyPage, {
        surveyId: linkDataSurvey[0],
        surveyType: linkDataSurvey[1],
      });
    } else if (item.servicoNotificacao == 2) {
      const linkArray: Array<string> = item.linkNotificacao.split("/");
      this.navCtrl.setRoot(TrainingPage, {
        trainingId: linkArray[linkArray.length - 1],
      });
    } else if (item.servicoNotificacao == 3) {
      this.navCtrl.push(IntermarketingDetailsPage, {
        id: item.id,
        messageId: item.mensagemId,
      });
    } else if (item.servicoNotificacao == 4) {
      const linkProject: Array<string> = item.linkNotificacao.split("?");
      this.navCtrl.setRoot(CronosProjectsPage, {
        projectId: linkProject[1],
        messageId: item.mensagemId,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intermarketing/intermarketing.ts